import React, { useState, useContext } from "react";
import "./Reserve.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

const Reserve = ({ setOpen, hotelId }) => {
  const [selectedRooms, setSelectedRooms] = useState([]);
  const { data: hotelData, loading, error } = useFetch(`/hotels/${hotelId}`);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSelect = (e) => {
    const checked = e.target.checked;
    const value = e.target.value;
    setSelectedRooms(
      checked
        ? [...selectedRooms, value]
        : selectedRooms.filter((item) => item !== value)
    );
  };

  const handleClick = async () => {
    if (!user) {
      alert("❌ Please log in to reserve rooms!");
      return;
    }
    if (selectedRooms.length === 0) {
      alert("Please select at least one room!");
      return;
    }

    try {
      // تجهيز بيانات الطلب
      const orderData = {
        userId: user._id,
        products: selectedRooms.map((room) => ({ productId: room, quantity: 1 })),
        amount: selectedRooms.length * hotelData.cheapestPrice, // يمكنك تعديل الحساب حسب حاجتك
        address: {
          city: hotelData.city,
          country: hotelData.country,
          hotel: hotelData.name,
        },
        status: "pending",
      };

      const token = user.token || localStorage.getItem("token");

      await axios.post("/orders", orderData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("✅ Reservation successful!");
      setOpen(false);
      navigate("/orders"); // تحويل المستخدم إلى صفحة الطلبات
    } catch (err) {
      console.error(err.response?.data || err.message);
      alert("❌ Reservation failed. Please try again.");
    }
  };

  return (
    <div className="reserve">
      <div className="rContainer">
        <FontAwesomeIcon
          icon={faCircleXmark}
          className="rClose"
          onClick={() => setOpen(false)}
        />
        <span>Select your rooms:</span>

        {loading ? (
          "Loading..."
        ) : error ? (
          <span>Error loading hotel</span>
        ) : hotelData.rooms && hotelData.rooms.length > 0 ? (
          hotelData.rooms.map((roomNumber) => (
            <div className="room" key={roomNumber}>
              <label>Room {roomNumber}</label>
              <input
                type="checkbox"
                value={roomNumber}
                onChange={handleSelect}
              />
            </div>
          ))
        ) : (
          <span>No rooms available in this hotel.</span>
        )}

        <button onClick={handleClick} className="rButton">
          Reserve Now!
        </button>
      </div>
    </div>
  );
};

export default Reserve;





